import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {GroupDiscountsListHeader} from './components/header/GroupDiscountsListHeader'
import {GroupDiscountsTable} from './table/GroupDiscountsTable'
import { GroupDiscountEditModal } from './GroupDiscount-edit-modal/GroupDiscountEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const GroupDiscountsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <GroupDiscountsListHeader />
        <GroupDiscountsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <GroupDiscountEditModal />}
    </>
  )
}

const GroupDiscountsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <GroupDiscountsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {GroupDiscountsListWrapper}
